import React from 'react';
import PropTypes from 'prop-types';
import './ThankyouPage.scss';
import ThankyouVideo from '../../images/videos/thankyou-page.mp4'
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';


const ThankyouPage = () => {

  const navigate = useNavigate();

  const canonicalUrl = "https://whitetowerinternational.com/Thankyou";
  
  return (
    <div className="ThankyouPage">
      <Helmet>
        <link rel="canonical" href={canonicalUrl} />
        <title>White Tower - Thankyou</title>
      </Helmet>
       <div className="inner-thankyoupage">
        <div className="video-thank-sec">
            <video disablePictureInPicture autoPlay muted loop id="video-background"  className='w-full h-full object-cover'>
              <source src={ThankyouVideo} type="video/mp4" />
            </video>
          </div>
          <div className="relative z-[999] flex flex-col items-center gap-6 thankyou-flexer-section">
            <h2 className='text-white font-semibold text-6xl text-center'>Thankyou For Contacting Us</h2>
            <p className='text-white font-semibold text-3xl text-center'>We Wil Get In Touch With You Shortly</p>
            <button onClick={() => navigate('/Home')} className='text-white bg-BlueTheme text-center w-fit rounded-full text-lg font-bold'>Go To Home</button>
          </div>
       </div>
    </div>
  );
}

ThankyouPage.propTypes = {};

ThankyouPage.defaultProps = {};

export default ThankyouPage;
